module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.addEditCollectionDivision) ? _c('div', {}, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('vue-form', {
    attrs: {
      "state": _vm.formstate
    }
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.status) + " Collection Division")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.addEditcollectionDivisions),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Ward / Society / Mohalla")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditcollectionDivisions),
      expression: "addEditcollectionDivisions"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "addEditcollectionDivisions",
      "required": "",
      "placeholder": "Ward / Society / Mohalla",
      "maxlength": "45",
      "pattern": "^[a-zA-Z][a-zA-Z0-9 @./#+-_]{0,45}[^\\s]$"
    },
    domProps: {
      "value": (_vm.addEditcollectionDivisions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addEditcollectionDivisions = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback validation_msg",
    attrs: {
      "name": "addEditcollectionDivisions",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                        Ward / Society / Mohalla is a required field\n                                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                        Alphabets/Numbers/Special Characters are allowed.\n                                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [(_vm.mode === 'create') ? _c('button', {
    class: 'mr-2 btn gradientbt',
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.addCollection
    }
  }, [_vm._v("\n                            Add\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.mode === 'edit') ? _c('button', {
    class: 'mr-2 btn gradientbt',
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateCollection
    }
  }, [_vm._v("\n                            Update\n                        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    class: 'mr-5  btn btn-default',
    on: {
      "click": _vm.onCloseCDD
    }
  }, [_vm._v("\n                            Cancel\n                        ")])])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isMapActive) ? _c('div', {}, [_c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('div', {
    staticClass: "d-flex justify-right"
  }, [_c('button', {
    class: 'mr-5 btn btn-default close-button',
    on: {
      "click": _vm.onCloseMap
    }
  }, [_vm._v("\n                                X\n                            ")])]), _vm._v(" "), (_vm.houseLocation) ? _c('div', {
    staticClass: "map-show"
  }, [_c('multiLocation')], 1) : _vm._e(), _vm._v(" "), (!_vm.houseLocation) ? _c('div', [_vm._v("\n                            No records Found\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isKmlShow) ? _c('div', {}, [_c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('div', {
    staticClass: "d-flex justify-right"
  }, [_c('button', {
    class: 'mr-5 btn btn-default close-button',
    on: {
      "click": _vm.closeKmlMap
    }
  }, [_vm._v("\n                                X\n                            ")])]), _vm._v(" "), (_vm.isKmlShow) ? _c('div', {
    staticClass: "map-show"
  }, [_c('kmlView')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.isUploadKmlPopUp) ? _c('div', {}, [_c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "rows form-modals modalbg"
  }, [_c('div', {
    staticClass: "d-flex justify-right"
  }, [_c('button', {
    class: 'mr-5 btn btn-default close-button',
    on: {
      "click": _vm.openUploadKmlPopup
    }
  }, [_vm._v("\n                                X ")])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "kmllabel"
  }, [_vm._v("File")]), _vm._v(" "), _c('input', {
    staticClass: "form-control kmlInput",
    attrs: {
      "type": "file",
      "accept": ".kml"
    },
    on: {
      "change": _vm.onDocumentchanged
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "form-control kmlButton",
    attrs: {
      "disabled": _vm.isKmlUpdateButtonEnable
    },
    on: {
      "click": _vm.uploadKmlFile
    }
  }, [_vm._v("Upload")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.loadingKlm) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader'), _vm._v(" "), _c('p', [_vm._v("Please wait, KML File is Uploading")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingKlm) ? _c('div', {
    staticClass: "collection_division_info collection_new_wrp"
  }, [_c('div', {
    staticClass: "row area-name area-name-bg"
  }, [_c('div', {
    staticClass: "area_inner_side"
  }, [_c('div', {
    staticClass: "area_inner"
  }, [_c('h4', [_vm._v("Area Name")]), _vm._v(" "), _c('div', {
    staticClass: "edit_side",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.details.areaName))]), _vm._v(" "), _c('button', {
    staticClass: "fa fa-edit",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editInfo(_vm.details)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "area_inner"
  }, [_c('h4', [_vm._v("City")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.cityId && _vm.details.cityId.cityName ? _vm.details.cityId.cityName : ""))])]), _vm._v(" "), _c('div', {
    staticClass: "area_inner right"
  }, [_c('button', {
    staticClass: "action_btn",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.houseLocationOnMap
    }
  }, [_vm._v("View Houses")])]), _vm._v(" "), (!this.details.routeFileUri || _vm.isUploadButton) ? _c('div', {
    staticClass: "area_inner right"
  }, [_c('button', {
    staticClass: "action_btn",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.openUploadKmlPopup
    }
  }, [_vm._v("Upload Route\n                        File")])]) : _vm._e(), _vm._v(" "), (_vm.isButtonEnable) ? _c('div', {
    staticClass: "area_inner right"
  }, [_c('button', {
    staticClass: "action_btn",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.openRoutePopupMap
    }
  }, [_vm._v("View Route")])]) : _vm._e(), _vm._v(" "), (_vm.isButtonEnable) ? _c('div', {
    staticClass: "area_inner right"
  }, [_c('button', {
    staticClass: "action_btn",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteLineModal()
      }
    }
  }, [_vm._v("Delete Route")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "area_inner_addnew_paddi"
  }, [_c('div', {
    staticClass: "area-name area_inner_addnew"
  }, [_c('h4', [_c('span', {
    staticClass: "text-justify"
  }, [_vm._v("Collection Divisions")]), _vm._v(" "), _c('div', {
    staticClass: "addcollecction_wrp"
  }, [_c('button', {
    staticClass: "btn gradientbt",
    on: {
      "click": _vm.addColletion
    }
  }, [_vm._v("\n                            Add Collection Division\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scroll-items"
  }, [_c('div', {
    staticClass: "details-card",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "collection_divisions_table"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.detailss), function(item) {
    return _c('tr', {
      key: item.divisionId
    }, [_c('td', [_vm._v("\n                                    " + _vm._s(item.divisionName) + "\n                                    "), _c('button', {
      staticClass: "fa fa-pencil",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editCdaName(item.divisionId, item)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.liness))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.housess))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "view_flex"
    }, [_c('button', {
      staticClass: "fa fa-home",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.viewHouse(item)
        }
      }
    }), _vm._v(" "), _c('div', {}, [_c('button', {
      staticClass: "fa fa-edit",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.ViewLineTower(item)
        }
      }
    })])])])])
  })], 2)])]), _vm._v(" "), (!_vm.showRecords) ? _c('div', {
    staticClass: "noRecords"
  }, [_vm._v("No Records Found")]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Ward / Society / Mohalla")]), _vm._v(" "), _c('th', [_vm._v("Line / Tower")]), _vm._v(" "), _c('th', [_vm._v("Houses / Flats")]), _vm._v(" "), _c('th', [_vm._v("Action")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79cca366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteCollectionArea/wasteCollectionAreaDetails.vue
// module id = 2364
// module chunks = 1